import { render, staticRenderFns } from "./trainspressmangexq.vue?vue&type=template&id=600fc8bd&scoped=true"
import script from "./trainspressmangexq.vue?vue&type=script&lang=js"
export * from "./trainspressmangexq.vue?vue&type=script&lang=js"
import style0 from "./trainspressmangexq.vue?vue&type=style&index=0&id=600fc8bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600fc8bd",
  null
  
)

export default component.exports